export const selector = 'dbMailTo';

/* @ngInject */
export default function MailToDirective($parse) {
    return {
        restrict: 'A',
        
        link: (scope, element, attrs) => {
            const getter = $parse(attrs[selector]);

            scope.$watch(() => getter(scope), (email) => {
                email = email ? `mailto:${email}` : null;

                attrs.$set('href', email);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/common/directive/mail-to/mail-to.directive.js